import { t } from "i18next";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { createUser } from "../../../../services/user";
import { useEffect, useState } from "react";
import { getClubOptions } from "../../../../services/club";
import { Club } from "../../../../interfaces/club";
import Select from 'react-select';
import { roleOptions } from "../../../../data/roles";

interface AdminUserNewProps {
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminUserNew(props: AdminUserNewProps) {
    const [clubOptions, setClubOptions] = useState<any[]>([]);
    const [clubs, setClubs] = useState<any[]>([]);
    const [selectedRole, setSelectedRole] = useState<any>({});

    useEffect(() => {
        getClubOptions()
            .then(response => {
                setClubOptions(response.data.map((c: Club) => {
                    return {
                        value: c.id,
                        label: c.name
                    }
                }));
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            first_name: event.target.first_name.value,
            last_name: event.target.last_name.value,
            email: event.target.email.value,
            phone: event.target.phone.value,
            document_id: event.target.document_id.value,
            birthdate: event.target.birthdate.value,
            club: clubs,
            role: event.target.role.value,
            status: 1
        }
        createUser(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleClubChange = (clubs: any) => {
        setClubs(clubs);
    }

    const handleRoleChange = (event: any) => {
        event.preventDefault();
        setClubs([]);
        const index = roleOptions.findIndex((r: any) => r.value == event.currentTarget.value);
        if (index !== -1) {
            setSelectedRole(roleOptions[index]);
        } else {
            setSelectedRole({});
        }
    }

    return (
        <Modal className="admin-user-new-container" show={ true }
            onHide={ handleClose } size="lg"> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("new_user") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Container>
                            <Row>
                                <Col xs={12} md={6}>
                                    <Form.Group className="mb-3" controlId="first_name">
                                        <Form.Label aria-required="true">{ t("first_name") }</Form.Label>
                                        <Form.Control type="text" name="first_name" required />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group className="mb-3" controlId="last_name">
                                        <Form.Label aria-required="true">{ t("last_name") }</Form.Label>
                                        <Form.Control type="text" name="last_name" required />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group className="mb-3" controlId="email">
                                        <Form.Label aria-required="true">{ t("email") }</Form.Label>
                                        <Form.Control type="email" name="email" required />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group className="mb-3" controlId="phone">
                                        <Form.Label>{ t("phone") }</Form.Label>
                                        <Form.Control type="text" name="phone" />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group className="mb-3" controlId="document_id">
                                        <Form.Label>{ t("document_id") }</Form.Label>
                                        <Form.Control type="text" name="document_id" />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group className="mb-3" controlId="birthdate">
                                        <Form.Label>{ t("birthdate") }</Form.Label>
                                        <Form.Control type="date" name="birthdate" />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6}>
                                    <Form.Group className="mb-3" controlId="role">
                                        <Form.Label aria-required="true">{ t("role") }</Form.Label>
                                        <Form.Select aria-label={ t("role") } onChange={ handleRoleChange }>
                                            <option value="">{ t("select_role") }</option>
                                            { roleOptions.filter((r: any) => ['padeltech_administrator', 'padeltech_manager'].includes(r.value)).map((r: any) => {
                                                return <option key={ 'role-' + r.value } value={r.value}>{ t(r.label) }</option>
                                            })}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                { selectedRole.value == 'padeltech_manager' &&
                                    <Col xs={12} md={6}>
                                        <Form.Group className="mb-3" controlId="club">
                                            <Form.Label aria-required="true">{ t("club") }</Form.Label>
                                            <Select name="club" required isMulti={ true } options={clubOptions} onChange={ handleClubChange } />
                                        </Form.Group>
                                    </Col>
                                }
                                {/*<Col xs={12}>
                                    <Form.Check
                                        className="mt-3"
                                        type="switch"
                                        name="status"
                                        label={ t("user_status_switch_label") }
                                        defaultChecked={ false }
                                        id="status-switch"
                                    />
                                </Col>*/}
                            </Row>
                        </Container>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}
